module.exports = __webpack_public_path__ + "img/IRM-mini.1bd5ce50.png";